export default __webpack_public_path__ + "static/media/check-completed.026e4e48.svg";